import {useEffect} from 'react';
import {Outlet, useNavigate} from 'react-router-dom';
import {ROUTES} from '@/routes/constants';
import {useAuth} from '@/services/auth';
import {useAppStore} from '@/services/store';
import {Spinner} from '@/ui-kit';
import {toRelativeUrl} from '@okta/okta-auth-js';

export const SecurePage = () => {
  const navigate = useNavigate();
  const {authState, setOriginalUri} = useAuth();
  const {setAuthToken} = useAppStore();
  const {isAuthenticated, accessToken: authData} = authState || {};

  useEffect(() => {
    if (!authState) {
      return;
    }

    if (!isAuthenticated) {
      const originalUri = toRelativeUrl(
        window.location.href,
        window.location.origin,
      );
      setOriginalUri(originalUri);
      navigate(ROUTES.LOGIN);
    }
  }, [navigate, authState, setOriginalUri, isAuthenticated]);

  useEffect(() => {
    if (isAuthenticated && authData?.accessToken) {
      setAuthToken(authData?.accessToken);
    }
  }, [authData?.accessToken, isAuthenticated, setAuthToken]);

  if (!isAuthenticated) {
    return <Spinner overlay={true} />;
  }

  return <Outlet />;
};
